export const setOrientation = (
  sound: Howl,
  posX: number,
  posY: number,
  posZ: number,
  yaw: number,
  pitch: number,
  soundPosX: number,
  soundPosY: number,
  soundPosZ: number,
) => {
  sound.pos(soundPosX, soundPosY, soundPosZ);
  Howler.pos(posX, posY, posZ);
  const radYaw = (yaw * Math.PI) / 180;
  const radPitch = (pitch * Math.PI) / 180;
  const forwardX = -Math.sin(radYaw) * Math.cos(radPitch);
  const forwardY = -Math.sin(radPitch);
  const forwardZ = Math.cos(radYaw) * Math.cos(radPitch);
  Howler.orientation(forwardX, forwardY, forwardZ, 0, 1, 0);
};
